import React, { useEffect } from 'react';
import { useFormikContext } from 'formik';

const FocusError = () => {
    const { errors, isSubmitting, isValidating } = useFormikContext();

    useEffect(() => {
        if (isSubmitting && !isValidating) {
            let keys = Object.keys(errors);
            if (keys.length > 0) {
                const selector = `[name=${keys[0]}]`;
                const errorElement = document.querySelector(selector) as HTMLElement;
                if (errorElement) {
                    const pos = errorElement.style.position;

                    const top = errorElement.style.top;

                    errorElement.style.position = 'relative';

                    errorElement.style.top = '-100px';

                    errorElement.scrollIntoView({ behavior: 'smooth', block: 'start' });

                    errorElement.style.top = top;

                    errorElement.style.position = pos;
                    errorElement.focus();

                }
            }
        }
    }, [errors, isSubmitting, isValidating]);

    return null;
};

export default FocusError;